<div class="tw-flex tw-flex-col tw-gap-2 tw-w-full">
  <div class="tw-flex tw-items-center tw-gap-2 tw-w-full">
    <p-password
      label="Enter password"
      [(ngModel)]="password"
      [toggleMask]="true"
      [feedback]="false"
      placeholder="Enter password"
      inputStyleClass="tw-w-full"
      styleClass="tw-w-full"
      (keyup.enter)="submit()"
      autofocus
    />
    <p-button
      label="Submit"
      [loading]="verifyingPassword"
      (onClick)="submit()"
    />
  </div>
  <div
    *ngIf="errorMessage"
    class="tw-text-red-500 tw-text-sm tw-mt-1"
  >
    {{ errorMessage }}
  </div>
</div>
